import { getAuthHeader } from "./serviceUtils";
export const postService = async( link, method, postData ) => {
    const auth = getAuthHeader(method);
    if (postData) {
        auth['body'] = JSON.stringify(postData || {})
    }
    try {
        const response = await window.fetch(`${link}`, auth)
        if(response){
            return response;
        }
     } catch(err) {
        console.error("Something went wrong in post service",err);
     }

}


// WEBPACK FOOTER //
// ./src/services/postService.ts